import React from 'react';
import { Building2 } from 'lucide-react';

interface BankComparisonEditorProps {
  settings: any;
  content: any;
  onSettingsChange: (settings: any) => void;
  onContentChange: (content: any) => void;
}

const BankComparisonEditor: React.FC<BankComparisonEditorProps> = ({ 
  settings, 
  content, 
  onSettingsChange, 
  onContentChange 
}) => {
  const handleSettingChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const newValue = type === 'checkbox' 
      ? (e.target as HTMLInputElement).checked 
      : type === 'number' 
        ? parseInt(value) 
        : value;
    
    onSettingsChange({ [name]: newValue });
  };
  
  return (
    <div className="space-y-6">
      {/* General Settings */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">Genel Ayarlar</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Başlık
            </label>
            <input
              type="text"
              name="title"
              value={settings?.title || 'Banka Karşılaştırma'}
              onChange={handleSettingChange}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            />
          </div>
          
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Maksimum Banka Sayısı
            </label>
            <input
              type="number"
              name="maxItems"
              value={settings?.maxItems || 4}
              onChange={handleSettingChange}
              min={1}
              max={10}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            />
          </div>
        </div>
        
        <div className="flex items-center gap-6">
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="showFeatures"
              checked={settings?.showFeatures !== false}
              onChange={handleSettingChange}
              className="rounded border-slate-300 text-[#F7BA45] focus:ring-[#F7BA45]"
            />
            <span className="text-sm text-slate-600">Özellikleri Göster</span>
          </label>
          
          <label className="flex items-center gap-2 cursor-pointer">
            <input
              type="checkbox"
              name="showRatings"
              checked={settings?.showRatings !== false}
              onChange={handleSettingChange}
              className="rounded border-slate-300 text-[#F7BA45] focus:ring-[#F7BA45]"
            />
            <span className="text-sm text-slate-600">Puanlamaları Göster</span>
          </label>
        </div>
      </div>
      
      {/* Product Type */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">Ürün Türü</h3>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            Karşılaştırılacak Ürün
          </label>
          <select
            name="productType"
            value={settings?.productType || 'loan'}
            onChange={handleSettingChange}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
          >
            <option value="loan">Kredi</option>
            <option value="card">Kredi Kartı</option>
            <option value="deposit">Mevduat</option>
          </select>
        </div>
        
        {settings?.productType === 'loan' && (
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Kredi Türü
            </label>
            <select
              name="loanType"
              value={settings?.loanType || 'ihtiyac'}
              onChange={handleSettingChange}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            >
              <option value="ihtiyac">İhtiyaç Kredisi</option>
              <option value="konut">Konut Kredisi</option>
              <option value="tasit">Taşıt Kredisi</option>
              <option value="kobi">Kobi Kredisi</option>
            </select>
          </div>
        )}
      </div>
      
      {/* Preview */}
      <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
        <div className="flex items-center gap-2 mb-2">
          <Building2 size={16} className="text-[#F7BA45]" />
          <h4 className="text-sm font-medium text-slate-700">Önizleme</h4>
        </div>
        <p className="text-sm text-slate-600">
          Banka karşılaştırma bileşeni, kullanıcıların farklı bankaların 
          {settings?.productType === 'loan' 
            ? ` ${settings?.loanType === 'ihtiyac' ? 'ihtiyaç kredisi' : 
                settings?.loanType === 'konut' ? 'konut kredisi' : 
                settings?.loanType === 'tasit' ? 'taşıt kredisi' : 'kobi kredisi'} ürünlerini` 
            : settings?.productType === 'card' 
              ? ' kredi kartı ürünlerini' 
              : ' mevduat ürünlerini'} 
          karşılaştırmasını sağlar.
        </p>
      </div>
    </div>
  );
};

export default BankComparisonEditor;